import { render } from "./CPGChat.vue?vue&type=template&id=47c9d394&scoped=true"
import script from "./CPGChat.vue?vue&type=script&lang=js"
export * from "./CPGChat.vue?vue&type=script&lang=js"

import "./CPGChat.vue?vue&type=style&index=0&id=47c9d394&lang=css"
import "./CPGChat.vue?vue&type=style&index=1&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=2&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=3&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=4&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=5&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=6&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=7&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=8&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=9&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=10&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=11&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=12&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=13&id=47c9d394&scoped=true&lang=css"
import "./CPGChat.vue?vue&type=style&index=14&id=47c9d394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c9d394"]])

export default __exports__